import axios from 'axios';

const getSupraPin = async (userId: string): Promise<number> => {
  const { data: pin } = await axios.get(`/supra_system/pin/${userId}`, {});

  return pin;
};

export default getSupraPin;
